import { NextSeo } from 'next-seo';
import Layout from '@components/common/Layout';

export default function About() {
  return (
    <>
      <NextSeo
        title="About Our Company"
        description="HLB Electric brings years of experience to your projects."
        canonical="https://www.hlbelectric.com/about"
        openGraph={{
          title: 'About Our Company | HLB Electric',
          url: 'https://www.hlbelectric.com/about',
          description:
            'HLB Electric brings years of experience to your projects.',
        }}
      />
      <div className="relative py-16 bg-white overflow-hidden">
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-lg max-w-prose mx-auto">
            <h1 className="text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              About HLB Electric
            </h1>
            <div className="mt-6 prose prose-lg text-gray-500 mx-auto">
              <p>
                I was introduced to the Electrical trade in 1995 by my uncle,
                Harrison Lee Boose. I was offered a position at Markee Electric
                Inc, one of the largest electrical contractors in Flint,
                Michigan. I started in the warehouse and worked my way up into a
                trade position at the Electrical Workers Union 948. I received
                my electrical apprenticeship through the Union, and since then
                was employed by several Union contracts throughout Michigan –
                residential, commercial, and industrial. Performing up to code
                is just as important now as when I started in the trade.
              </p>
              <p>
                In 2008, I moved to Arizona and was employed as a Lead
                Electrician and Supervisor for multiple companies in The Valley.
                I decided to fulfill my dream of owning my own electrical
                company. In honor of my uncle who passed away in 2020, I have
                named my company HLB Electric LLC. He told me, &quot;In this
                trade you can be your own boss&quot;. With this saying, I intend
                to service the Arizona area with the most professional owned
                electrical business in the area.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

About.Layout = Layout;
